import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, AlertController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';
import { MyaccountPage } from '../myaccount/myaccount';
import { ChangepassPage } from '../changepass/changepass';
import { NotificationPage } from '../notification/notification';
import { QnalistPage } from '../qnalist/qnalist';
import { MygroupPage } from '../mygroup/mygroup';
// import { MygrouphuPage } from '../mygrouphu/mygrouphu';
import { HuwonPage } from '../huwon/huwon';
import { LogoutModalPage } from '../logout-modal/logout-modal';
import { MultiaccountsPage } from '../multiaccounts/multiaccounts';
import { MultiregistPage } from '../multiregist/multiregist';
// import { MygrouphuPage } from '../mygrouphu/mygrouphu';
// import { MygrouphuPage } from '../mygrouphu/mygrouphu';
// import { BuyitemPage } from '../buyitem/buyitem';

/**
 * Generated class for the MypagePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-mypage',
    templateUrl: 'mypage.html',
})
export class MypagePage {

    params: any;
    items: any[];
	lang_list: any = [];

	rootPage: any;
	loginId: string;
	api_key: string;
    office_email: string;
    rank: string;
    email: string;
	jikgeup: string;
	version: string;
    
    public texts : any = [];
    public language : string;

    constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		private http: HttpService,
		public modalCtrl: ModalController,
		public alertCtrl: AlertController,
		public app: App,
    ) {

    }

    ionViewWillEnter() {
    	//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		this.loginId = localStorage.getItem("loginId");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}
		// 페이지 이름
        localStorage.setItem("pageName", "mypage");

        this.language = localStorage.getItem("language");
        this.email = localStorage.getItem("email");
        this.jikgeup = localStorage.getItem("jikgeup");
        this.office_email = localStorage.getItem("office_email");
		this.version = localStorage.getItem("version");
        
		this._lang_set()
		// this._init();
        
    }

    _changeLanguage() {
		setTimeout(() =>
        {
			localStorage.setItem("language",this.language);
			// let lang_list_i = this.lang_list.findIndex(i => i.code == this.language);
			this._lang_set();
        }, 250);		
	}
	
	_lang_set() {
		this._lang_list().then((res: any) => {
			this._lang(res).then((res: any) => {
				this._get_texts();
			});
		},(err)=>{	
			//// HTTP 에러인 경우
			let alert = this.alertCtrl.create({
				message: this.texts.alertM_err,
				buttons: ['OK']
			});
			alert.present();
		
		});
	}

	_lang_list() {
		return new Promise((resolve,reject)=>{
			let url = "common/language/list";
			let body = JSON.stringify({ 
				// divide: 'login',
				lang: this.language,
			});
			this.http.post(url, body).then((res: any) => {
				if(res.result=="OK"){
					this.lang_list = res.list;
					let lang_list_i = this.lang_list.findIndex(i => i.code == this.language);
					resolve(lang_list_i);
				} else {
					let alert = this.alertCtrl.create({
						message: res.message,
						buttons: ['OK']
					});
					alert.present();
				}
			},(err)=>{	
				//// HTTP 에러인 경우
				let alert = this.alertCtrl.create({
					message: this.texts.alertM_err,
					buttons: ['OK']
				});
				alert.present();
				reject(err);
			});	
		});
	}
	
	_lang(i) {
		return new Promise((resolve,reject)=>{
			let url = "common/language/json";
			let body = JSON.stringify({
				path: this.lang_list[i].path,
			});
			this.http.post(url, body).then((res: any) => {
				if(res.result=="OK"){
					let lang_pack = res.language[0];
					localStorage.removeItem('lang_pack');
					localStorage.setItem('lang_pack', JSON.stringify(lang_pack));
					resolve(res);
				} else {
					let alert = this.alertCtrl.create({
						message: res.message,
						buttons: ['OK']
					});
					alert.present();
				}
			},(err)=>{	
				//// HTTP 에러인 경우
				let alert = this.alertCtrl.create({
					message: this.texts.alertM_err,
					buttons: ['OK']
				});
				alert.present();
				reject(err);
			});
		});		

	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).mypage;
	}

	// _init() {
	// 	let send_data = JSON.stringify({
	// 		api: this.api_key,
    //         language: this.language,
	// 	});
	// 	this.http.post("common/index/office/email", send_data).then((res: any) => {
	// 		if(res.result == "OK") {
	// 			this.office_email = res.office_email;

	// 		} else if(res.result ==="LOGOUT"){
	// 			let alert = this.alertCtrl.create({
	// 				message: res.message,
	// 				buttons: ['OK']
	// 			});
	// 			alert.present();
	// 			localStorage.removeItem("loginId");
	// 			localStorage.removeItem("api_key");
	// 			this.app.getRootNav().setRoot(LoginPage);
			
	// 		} else {
	// 			let alert = this.alertCtrl.create({
	// 				message: res.message,
	// 				buttons: ['OK']
	// 			});
	// 			alert.present();
	// 		}
	// 	}, err => {
	// 		let alert = this.alertCtrl.create({
	// 			message: err,
	// 			buttons: ['OK']
	// 		});
	// 		alert.present();
	// 	});
	// }
    
    _event = (event: string): void => {
		if (event == "notice") {
			this.navCtrl.push(NotificationPage);
			// let alert = this.alertCtrl.create({
			// 	message: this.texts.alertM_ready,
			// 	buttons: ['OK']
			// });
			// alert.present();
        }
        if (event == "myaccount") {
            this.navCtrl.push(MyaccountPage);
        }
        if (event == "changepass") {
            this.navCtrl.push(ChangepassPage);
        }
        if (event == "chucheon") {
            this.navCtrl.push(MygroupPage);
		}
        if (event == "multi") {
            this.navCtrl.push(MultiaccountsPage);
        }
        if (event == "multi_add") {
            this.navCtrl.push(MultiregistPage);
        }
		if (event == "huwon") {
            this.navCtrl.push(HuwonPage);
		}
		if (event == "qna") {
			this.navCtrl.push(QnalistPage);
			
			// let alert = this.alertCtrl.create({
			// 	message: this.texts.alertM_ready,
			// 	buttons: ['OK']
			// });
			// alert.present();
        }
        if (event == "logout") {
			let modal = this.modalCtrl.create(LogoutModalPage);
			modal.present();
        }

	}

}



// WEBPACK FOOTER //
// ./src/pages/mypage/mypage.ts